import { AppModalActionType } from '../actiontype/app-modal.actiontype';

export function openLoginModal(redirection = false) {
    return { type: AppModalActionType.OPEN_LOGIN_MODAL, payload: { redirection } };
}

export function openOtpModal(redirection = false) {
    return { type: AppModalActionType.OPEN_OTP_MODAL, payload: { redirection } };
}

export function openSsoModal(redirection = false) {
    return { type: AppModalActionType.OPEN_SSO_MODAL, payload: { redirection } };
}

export function openNoAccountFoundModal(loginCallback = null,redirection = false) {
    return { type: AppModalActionType.OPEN_NO_ACCOUNT_FOUND_MODAL, payload: { redirection, loginCallback } };
}

export function openErrorModal(errorMsg, redirection = false) {
    return { type: AppModalActionType.OPEN_ERROR_MODAL, payload: { errorMsg, redirection } };
}

export function openOtpModalV2(redirection = false) {
    return { type: AppModalActionType.OPEN_OTP_MODAL_V2, payload: { redirection } };
}

export const openRetryModal = ( modalTitle, message, onRetry, redirection = false ) => {
    return { type: AppModalActionType.OPEN_RETRY_MODAL, payload: { modalTitle, message, onRetry, redirection } }
}

export const closeModal = () => dispatch => {
    dispatch(resetModal());
    dispatch(closeAppModal());
};

function closeAppModal() { return { type: AppModalActionType.CLOSE_MODAL } };

export function resetModal() { return { type: AppModalActionType.RESET_MODAL } };

export const setErrorModalCallback = (callback) => {
    return { type: AppModalActionType.SET_ERROR_MODAL_CALLBACK, payload: callback }
}